import { useParams } from 'react-router-dom';
import { useGetTemplateById } from '@/hooks/templates';
import EntityBreadcrumb from '../EntityBreadcrumb';
import { TemplateCrumbProps } from './types';

const TemplateCrumb = ({ param, isCurrentPage = false }: TemplateCrumbProps) => {
    const params = useParams();
    const templateId = params[param];
    const agentId = params.agentId;

    const { template, isLoadingTemplate } = useGetTemplateById({
        templateId: templateId || '',
        enabled: !!templateId,
    });

    const label = isLoadingTemplate
        ? '...'
        : template?.name || `Template ${templateId?.slice(0, 8)}...`;

    const href =
        agentId && templateId ? `/agents/${agentId}/templates/${templateId}` : '/templates';

    return (
        <EntityBreadcrumb
            label={label}
            entityId={templateId || ''}
            entityType="Template"
            href={href}
            isCurrentPage={isCurrentPage}
            isLoading={isLoadingTemplate}
        />
    );
};

export default TemplateCrumb;
